import { computed, ref } from 'vue'
import { useEventListener } from '@vueuse/core'

// Only descendants of a fullscreen element render while it is fullscreen.
export function useFullscreenTarget() {
  const fullscreenElement = ref<Element | null>(document.fullscreenElement ?? null)

  useEventListener(document, 'fullscreenchange', () => {
    fullscreenElement.value = document.fullscreenElement ?? null
  })

  return computed<Element | string>(() => fullscreenElement.value ?? 'body')
}
